import styles from "./PageLayout.module.scss";

interface PageLayoutProps {
  children: React.ReactNode;
}

export const PageLayout = ({ children }: PageLayoutProps) => {
  return <section className={styles.pagelayout}>{children}</section>;
};
